import React, { useState } from "react";
import axios from "axios";
import styles from "../styles.module.css";

const ViewEditUser = () => {
  // Pre-filled form data
  const [formData, setFormData] = useState({
    emailaddress: "Mrinal1@cretorial.com",
    driverpassword: "test123",
    First_Name: "John",
    Middle_Name: "Michael",
    Last_Name: "Doe",
    Date_of_Birth: "1990-05-15",
    Phone_Number: "123-456-7890",
    Street: "123 Main Street",
    City: "New York",
    State: "NY",
    Zip: "10001",
    companyid: "10032023050116762586",
    id: "10172023160040099650",
  });

  const [responseMessage, setResponseMessage] = useState("");

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const apiUrl = "https://casaahaanahotels.com/sb_editdriverregistrationsedit";
      const response = await axios.post(apiUrl, formData);
      setResponseMessage("Driver information updated successfully!");
    } catch (error) {
      setResponseMessage("Failed to update driver information. Please try again.");
    }
  };

  return (
    <div className={styles.editDriverContainer}>
      <h2 className={styles.editDriverHeader}>Edit Driver Information</h2>
      <form className={styles.editDriverForm} onSubmit={handleSubmit}>
        <div className={styles.formGroup}>
          <label>Email Address:</label>
          <input
            type="email"
            name="emailaddress"
            value={formData.emailaddress}
            onChange={handleChange}
            required
          />
        </div>
        <div className={styles.formGroup}>
          <label>Password:</label>
          <input
            type="password"
            name="driverpassword"
            value={formData.driverpassword}
            onChange={handleChange}
            required
          />
        </div>
        <div className={styles.formGroup}>
          <label>First Name:</label>
          <input
            type="text"
            name="First_Name"
            value={formData.First_Name}
            onChange={handleChange}
            required
          />
        </div>
        <div className={styles.formGroup}>
          <label>Middle Name:</label>
          <input
            type="text"
            name="Middle_Name"
            value={formData.Middle_Name}
            onChange={handleChange}
          />
        </div>
        <div className={styles.formGroup}>
          <label>Last Name:</label>
          <input
            type="text"
            name="Last_Name"
            value={formData.Last_Name}
            onChange={handleChange}
            required
          />
        </div>
        <div className={styles.formGroup}>
          <label>Date of Birth:</label>
          <input
            type="date"
            name="Date_of_Birth"
            value={formData.Date_of_Birth}
            onChange={handleChange}
            required
          />
        </div>
        <div className={styles.formGroup}>
          <label>Phone Number:</label>
          <input
            type="text"
            name="Phone_Number"
            value={formData.Phone_Number}
            onChange={handleChange}
            required
          />
        </div>
        <div className={styles.formGroup}>
          <label>Street:</label>
          <input
            type="text"
            name="Street"
            value={formData.Street}
            onChange={handleChange}
            required
          />
        </div>
        <div className={styles.formGroup}>
          <label>City:</label>
          <input
            type="text"
            name="City"
            value={formData.City}
            onChange={handleChange}
            required
          />
        </div>
        <div className={styles.formGroup}>
          <label>State:</label>
          <input
            type="text"
            name="State"
            value={formData.State}
            onChange={handleChange}
            required
          />
        </div>
        <div className={styles.formGroup}>
          <label>Zip:</label>
          <input
            type="text"
            name="Zip"
            value={formData.Zip}
            onChange={handleChange}
            required
          />
        </div>
        <div className={styles.formGroup}>
          <label>Company ID:</label>
          <input
            type="text"
            name="companyid"
            value={formData.companyid}
            onChange={handleChange}
            disabled
          />
        </div>
        <div className={styles.formGroup}>
          <label>ID:</label>
          <input
            type="text"
            name="id"
            value={formData.id}
            onChange={handleChange}
            disabled
          />
        </div>
        <button type="submit" className={styles.submitButton}>
          Submit
        </button>
      </form>
      {responseMessage && <p className={styles.responseMessage}>{responseMessage}</p>}
    </div>
  );
};

export default ViewEditUser;
